import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';

import { useCurrentUser, useCurrentUserUpdate, useEntitiesCreate } from '../../../hooks';
import { autocompleteEntities } from '../../../utils/backend-api/entities';
import { AutocompleteField, TextField } from '../../FormFields';
import StepContainer from './StepContainer';
import basicInfoSchema from './basicInfoSchema';

const INITIAL_VALUES = {
  title: { label: '', value: '' },
  company: { label: '', value: '' },
  oneLineBio: '',
};

const StepBasicInfo = ({ nextStep }) => {
  const { currentUser, isLoadingCurrentUser } = useCurrentUser();
  const { updateCurrentUser } = useCurrentUserUpdate();
  const { mutateAsync: createEntityAsync } = useEntitiesCreate();
  const [initialValues, setInitialValues] = useState(INITIAL_VALUES);

  const [error, setError] = useState();

  useEffect(() => {
    if (currentUser && !isLoadingCurrentUser) {
      setInitialValues({
        title: {
          label: currentUser?.title_at_company || '',
          value: currentUser?.title_at_company || '',
        },
        company: { label: currentUser?.company_name || '', value: currentUser?.company_name || '' },
        oneLineBio: currentUser?.one_line_bio || '',
      });
    }
  }, [isLoadingCurrentUser]);

  const handleSubmit = (values) => {
    setError(null);

    try {
      updateCurrentUser({
        title_at_company: values.title?.label,
        company_name: values.company?.label,
        one_line_bio: values.oneLineBio,
      });
      nextStep();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <StepContainer
      heading="Add basic info to your profile"
      subheading="Let people know who you are"
      error={error}
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={basicInfoSchema}
      >
        {(formik) => (
          <Form onSubmit={formik.handleSubmit}>
            <div className="content-wrapper">
              <div className="fields">
                <AutocompleteField
                  label="Title"
                  name="title"
                  fetchMethod={(value) =>
                    autocompleteEntities({
                      fragment: value,
                      entity_type: 'job_title',
                    })
                  }
                  createMethod={(value) =>
                    createEntityAsync({
                      name: value,
                      entity_type: 'job_title',
                      word_type: 'common',
                    })
                  }
                />
                <AutocompleteField
                  label="Company"
                  name="company"
                  fetchMethod={(value) =>
                    autocompleteEntities({
                      fragment: value,
                      entity_type: 'organization',
                      word_type: 'proper',
                    })
                  }
                  createMethod={(value) =>
                    createEntityAsync({
                      name: value,
                      entity_type: 'organization',
                      word_type: 'proper',
                    })
                  }
                />
                <TextField name="oneLineBio" label="One-line bio / pronouns" maxCharCount={40} />
              </div>

              <button
                type="submit"
                className="button button-red button-stretch button-small continue-button"
                disabled={formik.isSubmitting}
              >
                Continue
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </StepContainer>
  );
};

export default StepBasicInfo;
